/**
 * Analytics provider. Runs the identify lifecycle + pageview tracking and
 * exposes `resetIdentity` to descendants. Mount inside Auth + UserProfile
 * providers, outside RouterProvider. Inert when `config.heapAppId` is unset.
 */

import type { ReactNode } from 'react'
import type { AnyRouter } from '@tanstack/react-router'
import { AnalyticsContext, useIdentifyLifecycle, usePageviewTracking } from './analyticsLifecycle'

export interface AnalyticsProviderProps {
  children: ReactNode
  /** TanStack Router instance; when provided, route-template pageviews fire. */
  router?: AnyRouter
}

export function AnalyticsProvider({ children, router }: AnalyticsProviderProps) {
  const value = useIdentifyLifecycle()
  usePageviewTracking(router)
  return <AnalyticsContext.Provider value={value}>{children}</AnalyticsContext.Provider>
}
